{
  "title": "Ego Whip (UA)",
  "source": "Unearthed Arcana 66 - Fighter, Rogue, and Wizard",
  "levelAndSchool": "4th-level enchantment",
  "level": 4,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You lash the mind of one creature you can see within range, filling it with despair. The target must succeed on an Intelligence saving throw or suffer disadvantage on attack rolls, ability checks, and saving throws, and it can’t cast spells. At the end of each of its turns, the target can make another Intelligence saving throw. On a success, the spell ends on the target."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
